// ---------------------------------------------------------------
// Footer.js — Pie de la pantalla. Sin línea de separación: sólo el
// texto, para que no corte visualmente.
//
// Lleva la "información básica" sobre protección de datos (la primera
// capa que se usa en España: quién, para qué y qué derechos), con un
// enlace al aviso completo. Sale también en la pantalla de inicio de
// sesión, que es donde se ve ANTES de dar ningún dato, así que el
// aviso se abre aquí mismo, en una ventana, sin necesidad de entrar.
// ---------------------------------------------------------------
import { useEffect, useState } from "react";
import { PrivacyBody } from "./PrivacyGate";
import { PRIVACY_TITLE } from "../utils/privacyNotice";
import Icon from "./ui/Icon";

function AvisoPrivacidadModal({ onClose }) {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal footer-privacidad-modal"
        role="dialog"
        aria-modal="true"
        aria-label={PRIVACY_TITLE}
        onClick={(e) => e.stopPropagation()}
      >
        <header className="modal-header">
          <h2>{PRIVACY_TITLE}</h2>
          <button className="modal-close" onClick={onClose} aria-label="Cerrar">
            <Icon name="close" />
          </button>
        </header>
        <div className="footer-privacidad-cuerpo">
          <PrivacyBody />
        </div>
      </div>
    </div>
  );
}

export default function Footer() {
  const [verAviso, setVerAviso] = useState(false);

  return (
    <footer className="app-footer">
      <p className="footer-rgpd">
        <strong>Protección de datos.</strong> Responsable: Alberto Jiménez
        Buendía (Farmacia Buendía). Finalidad: organizar los turnos y llevar
        el registro de jornada. Derechos: acceso, rectificación, supresión,
        oposición, limitación y portabilidad, ante la dirección de la
        farmacia, y reclamación ante la AEPD (aepd.es).{" "}
        <button className="footer-rgpd-link" onClick={() => setVerAviso(true)}>
          Cómo tratamos tus datos
        </button>
      </p>
      <span>
        © {new Date().getFullYear()} Farmacia Buendía · &lt;/&gt; by{" "}
        <strong>@brundindev</strong>
        <br></br>
        [v1.0.15-d]
      </span>

      {verAviso && <AvisoPrivacidadModal onClose={() => setVerAviso(false)} />}
    </footer>
  );
}
